import React, { FC, PointerEvent as ReactPointerEvent, useCallback } from "react";
import { useDebouncedCallback } from "@evergis/react";

import { ChatWidthDrag } from "./styled";

import { useChatWidth } from "../../../hooks/chat/useChatWidth";

import { WidthDragProps } from "./types";

const MIN_CHAT_WIDTH = 300;
const MAX_CHAT_WIDTH = 700;
const DRAG_WIDTH = 24;

export const WidthDrag: FC<WidthDragProps> = ({ innerRef, disabled }) => {
  const debounce = useDebouncedCallback(0);
  const [chatWidth, setChatWidth] = useChatWidth();

  const onPointerDown = useCallback(
    (pointerDownEvent: ReactPointerEvent) => {
      const startPosition = { x: pointerDownEvent.pageX };

      const onPointerMove = (pointerMoveEvent: PointerEvent) => {
        const newWidth = chatWidth + startPosition.x - pointerMoveEvent.pageX;

        document.body.style.userSelect = "none";

        if (newWidth >= MIN_CHAT_WIDTH && newWidth <= Math.min(window.innerWidth - DRAG_WIDTH, MAX_CHAT_WIDTH)) {
          debounce(() => {
            setChatWidth(newWidth);
          });
        }
      };

      const onPointerUp = () => {
        document.body.style.userSelect = "initial";
        document.body.removeEventListener("pointermove", onPointerMove);
      };

      document.body.addEventListener("pointermove", onPointerMove);
      document.body.addEventListener("pointerup", onPointerUp, { once: true });
    },
    [chatWidth, debounce, setChatWidth],
  );

  return <ChatWidthDrag onPointerDown={onPointerDown} ref={innerRef} disabled={disabled} />;
};
